import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Category, ICategoryDataV3 } from '@df/catalog/category/category';
import { FacetOverridePipe } from '@df/module-facet-url/util/facet-override.pipe';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { ImageModule } from '@df/module-image/image.module';
import { NgInject } from '@df/ng/ng-inject';
import { VimeoPlayerComponent } from '@df/ui/display/media/vimeo-player.component';
import { YoutubePlayerComponent } from '@df/ui/display/media/youtube-player.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ICmsContentComponentValidationService } from '@icms/core/content/component/icms-content-component-validation.service';
import { getCmsContentFieldConfig } from '../../../../cms/components/components.config';
import { ICmsComponentContentData, ICmsContentVariant, ICmsContentVideoProvider } from '../../../../cms/components/components.interface';
import { ReadMoreComponent } from '../../display/read-more/read-more.component';

export namespace NCatregoryHeader {
    export interface ICategoryHeaderContentData extends ICmsComponentContentData {
        is_visible: boolean;
        image?: string;
    }
}

@Component({
    selector: 'category-header',
    templateUrl: './category-header.html',
    standalone: true,
    imports: [FacetOverridePipe, ReadMoreComponent, DfModuleImageModule, ImageModule, VimeoPlayerComponent, YoutubePlayerComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CategoryHeaderComponent>({
    id: 'category-header',
    block: {
        url: 'category-header'
    },
    onDemandOnly: true,
    name: 'Category Header',
    description: 'Content block used on listing page',
    fields: [
        <NICmsContentField.IField>{
            key: 'is_visible',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Show category header',
            required: true,
            default: false
        },
        ...getCmsContentFieldConfig('image')
    ]
})
export class CategoryHeaderComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content: NCatregoryHeader.ICategoryHeaderContentData;
    contentVariant = ICmsContentVariant;
    contentVideoProvider = ICmsContentVideoProvider;
    @Input()
    category: Category<ICategoryDataV3>;

    @Input()
    variant: string;

    @NgInject(ICmsContentComponentValidationService)
    iCmsContentComponentValidationService: ICmsContentComponentValidationService;

    override ngOnInit(): void {
        this.subscriptions.add(
            (this as NICmsContentComponent.IComponent).iCmsValidation$.subscribe(event => {
                if (event) {
                    if (!this.content.is_visible) {
                        event.error = {
                            level: 'info',
                            copy: 'Category header is hidden'
                        };
                    }
                    if (!this.category.data.name) {
                        event.error = { level: 'info', copy: 'Category name is missing' };
                    }
                }
            })
        );
        super.ngOnInit();
    }

    ngOnChanges(changes: any): void {
        super.ngOnChanges(changes);
        // force test on category change
        if (changes['category']) {
            (this as NICmsContentComponent.IComponent).iCmsValidation$?.next();
        }
    }
}
